import { useAuthStore } from '@/stores/retailer/auth.js'

export default function retailerRequireAuth(to, from, next) {
  const authStore = useAuthStore()

  if (authStore.getToken) {
    next()
  } else {
    next({
      path: '/login',
      query: {
        redirect: localStorage.getItem('next_route_retailer')
          ? localStorage.getItem('next_route_retailer')
          : to.fullPath
      }
    })
  }
}
